// import { faFacebook as fabFaFacebook } from '@fortawesome/pro-brands-svg-icons';
import { faSpinnerThird as fadSpinnerThird } from '@fortawesome/pro-duotone-svg-icons';

import {
  faExclamationCircle as falExclamationCircle,
  faFileCsv as falFileCsv,
  faFileExcel as falFileExcel,
  faChevronDown as falChevronDown,
  faChevronUp as falChevronUp,
  faTimes as falTimes,
  faArrowUp as falArrowUp,
  faArrowDown as falArrowDown,
  faBell as falBell,
  faInboxIn as falInboxIn,
  faEnvelope as falEnvelope,
  faUndo as falUndo,
  faPlus as falPlus,
  faReply as falReply,
  faPen as falPen,
  faSortDown as falSortDown,
  faSortUp as falSortUp,
  faChartBar as falChartBar,
  faChartLine as falChartLine,
  faTable as falTable,
  faCog as falCog,
  faChevronRight as falChevronRight,
  faChevronLeft as falChevronLeft,
  faWaveSquare as falWaveSquare,
  faChartPie as falChartPie,
  faCircleNotch as falCircleNotch,
  faBullseye as falBullseye,
  faBraille as falBraille,
  faCircle as falCircle,
  faTh as falTh,
  faSlidersH as falSlidersH,
  faSitemap as falSitemap,
  faCrosshairs as falCrosshairs,
  faThLarge as falThLarge,
  faBoxOpen as falBoxOpen,
  faHeading as falHeading,
  faDigitalTachograph as falDigitalTachograph,
  faHouse as falHouse,
  faSignalAlt as falSignalAlt,
  faFilter as falFilter,
  faAnalytics as falAnalytics,
  faHomeAlt as falHomeAlt,
  faWifiSlash as falWifiSlash,
  faHeartbeat as falHeartbeat,
  faBold as falBold,
  faItalic as falItalic,
  faStrikethrough as falStrikethrough,
  faUnderline as falUnderline,
  faListUl as falListUl,
  faListOl as falListOl,
  faQuoteRight as falQuoteRight,
  faCode as falCode,
  faFileCode as falFileCode,
  faLink as falLink,
  faUnlink as falUnlink,
  faImage as falImage,
  faRedo as falRedo,
  faEdit as falEdit,
  faExpand as falExpand,
  faCompress as falCompress,
  faAlignLeft as falAlignLeft,
  faAlignCenter as falAlignCenter,
  faAlignJustify as falAlignJustify,
  faAlignRight as falAlignRight,
} from '@fortawesome/pro-light-svg-icons';

import {
  faTimesCircle as farTimesCircle,
  faExclamationTriangle as farExclamationTriangle,
  faExclamationCircle as farExclamationCircle,
  faInfoCircle as farInfoCircle,
  faCheck as farCheck,
  faCheckCircle as farCheckCircle,
  faShieldCheck as farShieldCheck,
  faLaptop as farLaptop,
  faTrashAlt as farTrashAlt,
  faSave as farSave,
  faMugTea as farMugTea,
  faShield as farShield,
  faTimes as farTimes,
  faCalendarAlt as farCalendarAlt,
  faSuitcase as farSuitcase,
  faFileInvoiceDollar as farFileInvoiceDollar,
  faUserClock as farUserClock,
  faClock as farClock,
  faCalculator as farCalculator,
  faUsers as farUsers,
  faUserShield as farUserShield,
  faFileAlt as farFileAlt,
  faSearch as farSearch,
  faSitemap as farSitemap,
  faTrophy as farTrophy,
  faSmile as farSmile,
  faLightbulb as farLightbulb,
  faCommentDollar as farCommentDollar,
  faComment as farComment,
  faQuestion as farQuestion,
  faChalkboardTeacher as farChalkboardTeacher,
  faChevronDown as farChevronDown,
  faPen as farPen,
  faPlus as farPlus,
  faEye as farEye,
  faQuestionCircle as farQuestionCircle,
  faCog as farCog,
  faEllipsisH as farEllipsisH,
  faCopy as farCopy,
  faPrint as farPrint,
  faHeart as farHeart,
  faArrowsAlt as farArrowsAlt,
} from '@fortawesome/pro-regular-svg-icons';

import {
  faUndo as fasUndo,
  faMobileAlt as fasMobileAlt,
  faTrashAlt as fasTrashAlt,
  faCheck as fasCheck,
  faArrowLeft as fasArrowLeft,
  faArrowRight as fasArrowRight,
  faArrowUp as fasArrowUp,
  faArrowDown as fasArrowDown,
  faPen as fasPen,
  faPlus as fasPlus,
  faChevronDown as fasChevronDown,
  faTimes as fasTimes,
  faBell as fasBell,
  faInboxIn as fasInboxIn,
  faEnvelope as fasEnvelope,
  faExclamationTriangle as fasExclamationTriangle,
  faBars as fasBars,
  faChevronRight as fasChevronRight,
  faCloudDownload as fasCloudDownload,
  faHomeAlt as fasHomeAlt,
  faTable as fasTable,
  faChartBar as fasChartBar,
  faSignalAlt as fasSignalAlt,
  faChartLine as fasChartLine,
  faWaveSquare as fasWaveSquare,
  faChartPie as fasChartPie,
  faCircleNotch as fasCircleNotch,
  faBullseye as fasBullseye,
  faBraille as fasBraille,
  faCircle as fasCircle,
  faTh as fasTh,
  faSlidersH as fasSlidersH,
  faAlignCenter as fasAlignCenter,
  faSitemap as fasSitemap,
  faCrosshairs as fasCrosshairs,
  faThLarge as fasThLarge,
  faHeading as fasHeading,
  faAnalytics as fasAnalytics,
  faBold as fasBold,
  faStrikethrough as fasStrikethrough,
  faPrint as fasPrint,
  faHeart as fasHeart,
  faInfoCircle as fasInfoCircle,
  faAlignLeft as fasAlignLeft,
  faTasksAlt as fasTasksAlt,
} from '@fortawesome/pro-solid-svg-icons';
import convertFontAwesomeIcon from './convert-font-awesome-icon';

export const fontAwesomeIcons = [
  falExclamationCircle,
  falFileCsv,
  falFileExcel,
  falTimes,
  falArrowUp,
  falArrowDown,
  falBell,
  falInboxIn,
  falEnvelope,
  falChevronDown,
  falChevronUp,
  falUndo,
  falPlus,
  falReply,
  falPen,
  falChartBar,
  falChartLine,
  falTable,
  falCog,
  falChevronRight,
  falChevronLeft,
  falWaveSquare,
  falChartPie,
  falCircleNotch,
  falBullseye,
  falBraille,
  falCircle,
  falTh,
  falSlidersH,
  falSitemap,
  falCrosshairs,
  falThLarge,
  falBoxOpen,
  falHeading,
  falDigitalTachograph,
  falHouse,
  falSignalAlt,
  falFilter,
  falAnalytics,
  falHomeAlt,
  falWifiSlash,
  falHeartbeat,
  falBold,
  falItalic,
  falStrikethrough,
  falUnderline,
  falListUl,
  falListOl,
  falQuoteRight,
  falCode,
  falFileCode,
  falLink,
  falUnlink,
  falImage,
  falRedo,
  falEdit,
  falExpand,
  falCompress,
  falAlignLeft,
  falAlignCenter,
  falAlignJustify,
  falAlignRight,

  farTimes,
  farExclamationCircle,
  farExclamationTriangle,
  farInfoCircle,
  farCheck,
  farShieldCheck,
  farLaptop,
  farTrashAlt,
  farSave,
  farTimesCircle,
  farMugTea,
  farShield,
  farCalendarAlt,
  farSuitcase,
  farFileInvoiceDollar,
  farUserClock,
  farClock,
  farCalculator,
  farUsers,
  farUserShield,
  farFileAlt,
  farTrophy,
  farSearch,
  farSitemap,
  farSitemap,
  farSmile,
  farLightbulb,
  farCommentDollar,
  farComment,
  farQuestion,
  farCheckCircle,
  farChalkboardTeacher,
  farChevronDown,
  farPen,
  farPlus,
  farEye,
  farQuestionCircle,
  farCog,
  farEllipsisH,
  farCopy,
  farPrint,
  farHeart,
  farArrowsAlt,

  fasUndo,
  fasMobileAlt,
  fasTrashAlt,
  fasCheck,
  fasArrowLeft,
  fasArrowRight,
  fasArrowDown,
  fasArrowUp,
  fasPen,
  fasPlus,
  fasChevronDown,
  fasTimes,
  fasBell,
  fasInboxIn,
  fasEnvelope,
  fasExclamationTriangle,
  fasBars,
  fasChevronRight,
  fasCloudDownload,
  fasHomeAlt,
  fasTable,
  fasChartBar,
  fasSignalAlt,
  fasChartLine,
  fasWaveSquare,
  fasChartPie,
  fasCircleNotch,
  fasBullseye,
  fasBraille,
  fasCircle,
  fasTh,
  fasSlidersH,
  fasAlignCenter,
  fasSitemap,
  fasCrosshairs,
  fasThLarge,
  fasHeading,
  fasAnalytics,
  fasPen,
  fasUndo,
  fasBold,
  fasStrikethrough,
  fasPrint,
  fasHeart,
  fasInfoCircle,
  fasAlignLeft,
  fasTasksAlt,

  fadSpinnerThird,
];
export const kendoIconOverrides = {
  type: 'svg',
  icons: {
    'chevron-up': convertFontAwesomeIcon(falChevronUp),
    'chevron-down': convertFontAwesomeIcon(falChevronDown),
    'sort-asc-small': convertFontAwesomeIcon(falSortUp),
    'sort-desc-small': convertFontAwesomeIcon(falSortDown),
    'caret-alt-right': convertFontAwesomeIcon(falChevronRight),
    'caret-alt-left': convertFontAwesomeIcon(falChevronLeft),
    'caret-alt-down': convertFontAwesomeIcon(falChevronDown),
    search: convertFontAwesomeIcon(farSearch),
    x: convertFontAwesomeIcon(falTimes),
    'x-circle': convertFontAwesomeIcon(falTimes),
  },
};
